 import AuthGate from "./authGate.jsx";
 import { AuthProvider } from "./context/AuthContext.jsx";
 import { AppCore } from "./components/AppCore.jsx";
 import { AppProviders } from "./components/AppProviders.jsx";
 import { Toaster } from "@/components/ui/toaster";
 import { useSubscription } from "./context/SubscriptionContext.jsx";
 import { useConfig } from "./context/ConfigContext.jsx";
 import { FirebaseActionHandler } from "./components/FirebaseActionHandler.jsx";

 const rutappLogo = "/images/rutapp-logo.png.png";

 // AppReadyGate: Mantiene visible el logo hasta que plan Y config estén resueltos.
 // Evita flash de Free/Perfil/RUTAPP mientras se cargan internal entitlements,
 // settings/profiles o workspace._meta. Sin timeout silencioso: si alguna fuente
 // no responde, el splash permanece visible en vez de consolidar datos no confirmados.
 function AppReadyGate({ children }) {
   const { isPlanReady } = useSubscription();
   const { isConfigReady } = useConfig();

   if (!isPlanReady || !isConfigReady) {
     return (
       <div className="w-full h-screen flex flex-col items-center justify-center gap-4 bg-black">
         <img
           src={rutappLogo}
           alt="Rutapp"
           className="h-28 w-auto opacity-90"
         />
       </div>
     );
   }
   return children;
 }

 export default function App() {
  const params = new URLSearchParams(window.location.search);
  const isFirebaseAction =
    params.has("mode") && params.has("oobCode");

  if (isFirebaseAction) {
    return <FirebaseActionHandler />;
  }

  return (
     <AuthGate>
       <AuthProvider>
         <AppProviders>
           <AppReadyGate>
             <AppCore />
             <Toaster />
           </AppReadyGate>
         </AppProviders>
       </AuthProvider>
     </AuthGate>
   );
 }


